'use strict';

var React = require('react');

var SvgDiscountAutomaticMajor = function SvgDiscountAutomaticMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.707 7.707 6-6a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0 1.414 1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 0a1 1 0 0 0 0 2h1v12.17a3.001 3.001 0 1 0 3.83 1.83h5.34a3 3 0 1 0 2.83-2h-10v-2h11.566a1.5 1.5 0 0 0 1.485-1.288l.939-6.57a1 1 0 0 0-1.98-.283l-.877 6.141h-11.133v-8.5a1.5 1.5 0 0 0-1.5-1.5h-1.5zm13 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-11 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
  }));
};

exports.SvgDiscountAutomaticMajor = SvgDiscountAutomaticMajor;
